module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.group) ? _c('div', {
    ref: "modal",
    staticClass: "modal fade",
    attrs: {
      "id": "modalAccount"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: {
      'modal-lg': _vm.showingHistory
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("account.title")) + " " + _vm._s(_vm.group.name))])]), (_vm.paying) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _c('h4', [_vm._v(_vm._s(_vm.$t('account.gettingPayement')))])])]) : _vm._e(), (!_vm.paying) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('space-view', {
    attrs: {
      "divs": _vm.spaceViewDivs
    }
  }), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-center"
  }, [_vm._v(_vm._s(_vm.$t("account.usedSpace")) + " : " + _vm._s(_vm._f("hrS")(_vm.group.storageSize)))]), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_vm._v(_vm._s(_vm.$t("account.freeSpace")) + " : " + _vm._s(_vm._f("hrS")(_vm.freeSpace)))])]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t("account.maxSpace")) + " : " + _vm._s(_vm._f("hrS")(_vm.group.storageMax))), _c('br'), (_vm.group.storageEnd) ? _c('small', [_vm._v(_vm._s(_vm.$t("account.limitDate")) + " " + _vm._s(_vm._f("unixtimeTo")(_vm.group.storageEnd, "L LT")))]) : _c('small', [_vm._v(_vm._s(_vm.$t("account.noLimitDate")))]), (!_vm.showingBuyQuota) ? [_c('br'), _c('br'), _c('div', {
    staticClass: "btn btn-default",
    class: {
      'btn-success': _vm.isDefaultQuota
    },
    on: {
      "click": _vm.showBuyQuota
    }
  }, [(_vm.isDefaultQuota) ? [_vm._v(_vm._s(_vm.$t('account.getMoreSpaceBtn')))] : [_vm._v(_vm._s(_vm.$t('account.renewSpaceBtn')))]], 2)] : _vm._e()], 2)]), (_vm.showingBuyQuota) ? _c('div', {
    staticClass: "buyQuota"
  }, [_c('hr'), _c('h4', [_vm._v(_vm._s(_vm.$t("account.buyQuota.title")))]), _c('div', {
    staticClass: "table-responsive"
  }, [(!_vm.showingSpaceRange) ? _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("hrS")(_vm.selectedSpaceRange.space * 1024 * 1024)))]), _c('td', [_vm._v(_vm._s(_vm.$t('account.buyQuota.from')) + " " + _vm._s(_vm._f("unixtimeTo")(_vm.group.storageEnd, "L")) + " " + _vm._s(_vm.$t('account.buyQuota.to')) + " " + _vm._s(_vm._f("unixtimeTo")(_vm.storageEndPlusOneYear, "L")) + " " + _vm._s(_vm.$t('account.buyQuota.oneYear')))]), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.selectedSpaceRange.price) + " €")])]), (_vm.balance.status == 'loaded' && _vm.balance.value > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.buyQuota.previousBalance'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t('account.buyQuota.unused')))])]), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("-" + _vm._s(_vm.balance.value) + " €")])]) : _vm._e(), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.buyQuota.toPay')))]), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.totalToPay) + " €")])])])]) : _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('tbody', [_vm._l((_vm.spaceRanges), function(range) {
    return _c('tr', {
      staticClass: "clickable",
      class: {
        warning: _vm.toMega(range.space) < _vm.group.storageSize
      },
      on: {
        "click": function($event) {
          return _vm.selectSpaceRange(range)
        }
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedSpaceRange),
        expression: "selectedSpaceRange"
      }],
      attrs: {
        "type": "radio",
        "name": "spaceSelected"
      },
      domProps: {
        "value": range,
        "checked": _vm._q(_vm.selectedSpaceRange, range)
      },
      on: {
        "change": function($event) {
          _vm.selectedSpaceRange = range
        }
      }
    })]), _c('td', [_c('div', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(_vm._f("hrS")(range.space * 1024 * 1024)))])]), _c('td', [(_vm.toMega(range.space) < _vm.group.storageSize) ? _c('small', [_vm._v("(" + _vm._s(_vm.$t('account.buyQuota.tooSmall')) + ")  ")]) : _vm._e(), (!range.from) ? [_vm._v(_vm._s(_vm.$t('account.buyQuota.illimited')))] : [_vm._v(_vm._s(_vm.$t('account.buyQuota.from')) + " " + _vm._s(_vm._f("unixtimeTo")(range.from / 1000, "L")) + "\n " + _vm._s(_vm.$t('account.buyQuota.to')) + " " + _vm._s(_vm._f("unixtimeTo")(range.to / 1000, "L")))]], 2), _c('td', {
      staticClass: "text-right nowrap"
    }, [_vm._v(_vm._s(range.price) + " €")])])
  }), (_vm.balance.status == 'loaded' && _vm.balance.value > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.buyQuota.previousBalance'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t('account.buyQuota.unused')))])]), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("-" + _vm._s(_vm.balance.value) + " €")])]) : _vm._e(), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.buyQuota.toPay')))]), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.totalToPay) + " €")])])], 2)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "clickable",
    on: {
      "click": _vm.toggleSpaceRange
    }
  }, [(!_vm.showingSpaceRange) ? [_vm._v(_vm._s(_vm.$t('account.buyQuota.changeSpaceToggler')))] : _vm._e(), (_vm.showingSpaceRange && !_vm.isDefaultQuota) ? [_vm._v(_vm._s(_vm.$t('account.buyQuota.dontChangeSpaceToggler')))] : _vm._e()], 2)]), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.pay
    }
  }, [(_vm.totalToPay == '0.00') ? [_vm._v(_vm._s(_vm.$t('account.buyQuota.accept')))] : [_vm._v(_vm._s(_vm.$t('account.buyQuota.pay')))]], 2)])])]) : _vm._e(), (_vm.showingHistory) ? _c('div', {
    staticClass: "history"
  }, [_c('hr'), _c('h4', [_vm._v(_vm._s(_vm.$t('account.history.title')))]), (_vm.invoices.status == 'loading') ? [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t("globals.loading")))] : _vm._e(), (_vm.invoices.status == 'error') ? [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.$t("globals.error")))] : _vm._e(), (_vm.invoices.status == 'loaded') ? [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('account.history.date')))]), _c('th', [_vm._v(_vm._s(_vm.$t('account.history.explanation')))]), _c('th', [_vm._v(_vm._s(_vm.$t('account.history.amount')))]), _c('th', [_vm._v(_vm._s(_vm.$t('account.history.status')))])])]), _c('tbody', _vm._l((_vm.invoices.elems), function(invoice) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm._f("unixtimeTo")(invoice.creationTime, "L LT"))), (invoice.user) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('account.history.by')) + " " + _vm._s(invoice.user.name))])]) : _vm._e()]), _c('td', [_vm._v(_vm._s(_vm.$t("account.invoices.comment." + invoice.comment))), (invoice.quota) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('account.history.quota')) + " : " + _vm._s(_vm._f("hrS")(invoice.quota * 1024 * 1024)))])]) : _vm._e(), (invoice.untilDate) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('account.history.until')) + " " + _vm._s(_vm._f("unixtimeTo")(invoice.untilDate, "L LT")))])]) : _vm._e(), (invoice.closingDate && invoice.closingDate != invoice.untilDate) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('account.history.stopBefore')) + " " + _vm._s(_vm._f("unixtimeTo")(invoice.closingDate, "L LT")))])]) : _vm._e()]), _c('td', [(invoice.price != 0) ? [_vm._v(_vm._s(invoice.currency) + " " + _vm._s(Math.abs(invoice.price)))] : [_vm._v("- ")]], 2), _c('td', [(invoice.status) ? [_c('div', {
      staticClass: "badge",
      class: {
        success: invoice.status == 'PAID', danger: invoice.status == 'CANCELLED'
      }
    }, [_vm._v(_vm._s(_vm.$t("account.invoices.status." + invoice.status)))]), (invoice.paidDate) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm._f("unixtimeTo")(invoice.paidDate, "L LT")))])]) : _vm._e()] : _vm._e()], 2)])
  }), 0)])])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e(), (!_vm.paying) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('label', {
    staticClass: "clickable"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showingHistory),
      expression: "showingHistory"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showingHistory) ? _vm._i(_vm.showingHistory, null) > -1 : (_vm.showingHistory)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showingHistory,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showingHistory = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showingHistory = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showingHistory = $$c
        }
      }
    }
  }), _vm._v("  " + _vm._s(_vm.$t("account.history.toggle")))])]), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.$t("globals.close")))])])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be6a8296","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Files/ModalAccount.vue
// module id = 1283
// module chunks = 1